import {
  Box,
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Stack,
  Text,
  useToast,
} from "@chakra-ui/react";
import axios from "axios";
import jwtDecode from "jwt-decode";
import React, { useState } from "react";
import DecryptToken from "../../../utils/secure/DecryptToken";
import PasswordForm from "../../forms/PasswordForm";

export default function ResetPassword() {
  const passwordChecker = new RegExp(
    "(?=[A-Za-z0-9@#$%^&+!=]+$)^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,}).*$"
  );
  const baseURL = process.env.REACT_APP_BASE_URL;
  const token = localStorage.getItem("access_token");
  const UID = jwtDecode(token)?.data.id;
  const toast = useToast();

  const [data, setData] = useState({
    old_password: "",
    new_password: "",
    new_password2: "",
  });

  const [error, setError] = useState({
    old_password: false,
    new_password: false,
    new_password2: false,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
    if (name === "new_password") {
      if (!passwordChecker.test(value)) {
        console.log("test");
        setError({ ...error, [name]: true });
      } else {
        console.log("11");
        setError({ ...error, [name]: false });
      }
    }
    if (name === "new_password2") {
      if (value !== data.new_password) {
        setError({ ...error, [name]: true });
      } else {
        setError({ ...error, [name]: false });
      }
    }
  };

  const handleSave = () => {
    axios
      .patch(baseURL + "/users/" + UID + "/password", data, {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        console.log(res);
        if (res.status === 200) {
          toast({
            title: "Data Berhasil Disimpan",
            description: "Perubahan Data Pada Profile Berhasil Disimpan",
            status: "success",
            duration: 5000,
            isClosable: true,
          });
        }
      })
      .catch((e) => {
        if (e.response.status === 403) {
          console.log(e);
          setError(e.response.data.error.message);
        }
      });
  };

  return (
    <div>
      <Stack spacing={5} py="3">
        <Text fontWeight="500" fontSize={20}>
          Ganti Kata Sandi
        </Text>
        <Text fontWeight="400" fontSize={12}>
          Masukkan kata sandi baru sedikitnya 8 karakter serta kata sandi harus
          mengandung huruf dan angka.
        </Text>
        <FormControl>
          <FormLabel>Kata Sandi Lama</FormLabel>
          <PasswordForm
            placeholder="Masukkan kata sandi lama"
            name="old_password"
            handleChange={handleChange}
          />
        </FormControl>
        <FormControl isInvalid={error.new_password}>
          <FormLabel>Kata Sandi Baru</FormLabel>
          <PasswordForm
            placeholder="Masukkan kata sandi baru"
            name="new_password"
            handleChange={handleChange}
          />
          <FormErrorMessage>
            Kata sandi sedikitnya harus 8 karakter , mengandung huruf (kecil &
            besar) dan angka
          </FormErrorMessage>
        </FormControl>
        <FormControl isInvalid={error.new_password2}>
          <FormLabel>Konfirmasi Kata Sandi Baru</FormLabel>
          <PasswordForm
            placeholder="Konfirmasi kata sandi baru"
            name="new_password2"
            handleChange={handleChange}
          />
          <FormErrorMessage>Harus sama dengan kata sandi baru</FormErrorMessage>
        </FormControl>
        <Box>
          <Button
            disabled={
              data.new_password === "" ||
              data.new_password2 === "" ||
              data.old_password === "" ||
              error.new_password ||
              error.new_password2 ||
              error.old_password
            }
            px="10"
            colorScheme="blue"
            variant="outline"
            onClick={handleSave}
          >
            Simpan Kata Sandi Baru
          </Button>
        </Box>
      </Stack>
    </div>
  );
}
